import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, LayoutDashboard, List, Calculator, FilePlus, Target, ChevronLeft } from 'lucide-react';
import { APP_TITLE } from '@/lib/brand';

interface HeaderProps {
  onMenuClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const location = useLocation();
  const path = location.pathname;

  const crumbs = (() => {
    if (path === '/') return [{ label: 'داشبورد' }];
    if (path === '/analyses') return [{ label: 'داشبورد', to: '/' }, { label: 'لیست آنالیزها' }];
    if (path === '/analyses/create') return [{ label: 'داشبورد', to: '/' }, { label: 'لیست آنالیزها', to: '/analyses' }, { label: 'آنالیز جدید' }];
    if (path.match(/^\/analyses\/\d+$/)) return [{ label: 'داشبورد', to: '/' }, { label: 'لیست آنالیزها', to: '/analyses' }, { label: 'کارگاه آنالیز' }];
    if (path === '/bid-domain') return [{ label: 'داشبورد', to: '/' }, { label: 'تعیین دامنه' }];
    return [{ label: APP_TITLE }];
  })();

  const getTitle = () => crumbs[crumbs.length - 1]?.label ?? APP_TITLE;

  const getIcon = () => {
    if (path === '/') return LayoutDashboard;
    if (path === '/analyses') return List;
    if (path === '/analyses/create') return FilePlus;
    if (path === '/bid-domain') return Target;
    return Calculator;
  };

  const Icon = getIcon();

  return (
    <header
      className="border-b border-slate-200 bg-white h-14 flex items-center justify-between px-3 lg:px-6 shrink-0 z-10"
      dir="rtl"
    >
      <button
        type="button"
        onClick={onMenuClick}
        className="min-w-[44px] min-h-[44px] p-2 -m-1 rounded-xl hover:bg-slate-100 lg:hidden flex items-center justify-center text-slate-800"
        aria-label="منو"
      >
        <Menu size={22} />
      </button>

      <div className="hidden lg:flex items-center gap-2 min-w-0 text-sm">
        {crumbs.map((crumb, index) => (
          <React.Fragment key={`${crumb.label}-${index}`}>
            {index > 0 && <ChevronLeft size={14} className="text-slate-300" />}
            {crumb.to ? (
              <Link to={crumb.to} className="text-slate-500 hover:text-emerald-800 font-medium">
                {crumb.label}
              </Link>
            ) : (
              <h2 className="text-base font-bold text-slate-900 truncate">{crumb.label}</h2>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className="flex items-center gap-2 min-w-0 flex-1 justify-end lg:flex-none">
        <span className="text-sm font-bold text-slate-900 truncate lg:hidden">{getTitle()}</span>
        <div className="bg-[#0a4d29] p-2 rounded-lg shrink-0">
          <Icon size={16} className="text-white" />
        </div>
      </div>
    </header>
  );
};

export default Header;
